/**
 * State used in rendering ProgressBar
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
